import React, { useEffect, useState } from "react";

const AdminNotificationToast = ({ data, onClose }) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const audio = new Audio("/sounds/notify.mp3"); // 🔔 добавь этот файл
        audio.volume = 0.3;
        audio.play().catch(() => { });

        setVisible(true);
        const timer = setTimeout(() => {
            setVisible(false);
            setTimeout(onClose, 500); // даём время для анимации исчезновения
        }, 5000);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div className={`toast ${visible ? "show" : "hide"}`}>
            <div className="toast__header">
                <strong>{data.title}</strong>
                <span className="toast__time">
                    {new Date(data.createdAt).toLocaleTimeString("ru-RU", {
                        hour: "2-digit",
                        minute: "2-digit",
                    })}
                </span>
            </div>
            <div className="toast__body">{data.message}</div>
        </div>
    );
};

export default AdminNotificationToast;
